/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Fatura_IptalInputs */

const tr_faq_q_fatura_iptal = /** @type {(inputs: Faq_Q_Fatura_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatura iptali ve yeniden kesim nasıl çalışır?`)
};

const en_faq_q_fatura_iptal = /** @type {(inputs: Faq_Q_Fatura_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does invoice cancellation work?`)
};

const de_faq_q_fatura_iptal = /** @type {(inputs: Faq_Q_Fatura_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie funktioniert die Rechnungsstornierung?`)
};

const ru_faq_q_fatura_iptal = /** @type {(inputs: Faq_Q_Fatura_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как работает отмена счёта?`)
};

/**
* | output |
* | --- |
* | "How does invoice cancellation work?" |
*
* @param {Faq_Q_Fatura_IptalInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_fatura_iptal = /** @type {((inputs?: Faq_Q_Fatura_IptalInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Fatura_IptalInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_fatura_iptal(inputs)
	if (locale === "de") return de_faq_q_fatura_iptal(inputs)
	if (locale === "ru") return ru_faq_q_fatura_iptal(inputs)
	return tr_faq_q_fatura_iptal(inputs)
});